import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { DateComparator } from '../../../components/common/DateComparator';

export const EditPlannerMaterialHeaders = (onClickEditExistingRecords, onClickDeleteLineItem, userRole) => {
    return [
        {
            field: "uniqueId",
            headerName: "ID",

        },
        {
            field: "plant",
            headerName: "Plant",

        },
        {
            field: "purchasingGroup",
            headerName: "Purchasing Group",

        },
        {
            field: "plannerName",
            headerName: "Planner/MRP Controller",

        },
        {
            field: "plannerEmail",
            headerName: "Planner Email ID",

        },
         {
            field: "role",
            headerName: "Role",

        },
        {
            field: "scode",
            headerName: "S-Code (Ext Material Group)",

        },
        {
            field: "materialType",
            headerName: "Material Type",

        },
        {
            field: "materialGroup",
            headerName: "Material Group",

        },
        {
            field: "materialId",
            headerName: "Material",
            cellRenderer: (response) => {
                return (
                    <span><a href={`${process.env.REACT_APP_SAP_FIORI_MATERIAL_MASTER_DISPLAY_BASE_URL}?sap-client=010&sap-language=EN#Material-display?Material=${response?.value}`} target="_blank" style={{ color: '#000', cursor: 'pointer' }}>{response?.value || "-"}</a></span>
                )
            }

        },
        {
            field: "createdTsp",
            headerName: "Created On",
            comparator: DateComparator,
            // filter: 'agDateColumnFilter',

        },
        {
            field: "modifiedTsp",
            headerName: "Updated On",
            comparator: DateComparator,
            // filter: 'agDateColumnFilter',

        },
        {
            field: "Actions",
            headerName: "Actions",
            width: 120,
            cellRenderer: (response) => (
                <div className="btn-wrapper" style={{ marginTop: 6 }} >
                    <EditIcon onClick={() => onClickEditExistingRecords(response)} style={{ cursor: 'pointer' }} />
                    <DeleteIcon onClick={() => onClickDeleteLineItem(response)} style={{ cursor: 'pointer' }} />
                </div>
            ),
            pinned: 'right',
            lockPinned: true,
            lockPosition: true,
            hide: userRole === "Viewer" ? true : false
        },
    ]
}